// frontend/src/firebase.js

// Import Firebase modules
import { initializeApp } from "firebase/app"; // Core Firebase SDK
import { getFirestore } from "firebase/firestore"; // Firestore database
import { getAuth, signInAnonymously } from "firebase/auth"; // Firebase Authentication

// Firebase configuration object
// Values are pulled from environment variables for security
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY, // API key for Firebase project
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN, // Auth domain for login
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID, // Project ID
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET, // Storage bucket URL
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID, // Messaging sender ID
  appId: process.env.REACT_APP_FIREBASE_APP_ID, // App ID
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID, // Analytics measurement ID
};

// Initialize Firebase app with the config
const app = initializeApp(firebaseConfig);

// Initialize Firestore database instance
const db = getFirestore(app);

// Initialize Firebase Auth instance
const auth = getAuth(app);

// Sign in anonymously to allow Firestore access without user credentials
// This is useful for public read/write operations that don't require full user login
signInAnonymously(auth).catch((error) =>
  console.error("Firebase Auth Error:", error) // Log any auth errors
);

// Export the Firestore database instance for use in other modules
export { db };
